module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-46.a3db3d65.png";